<template>
  <div class="lead">
    <div class="container">
      <div class="inner">
        <img
          class="headbg"
          src="../assets/img/head-draw.svg"
        >
        <img
          class="headline"
          src="../assets/img/headline.svg"
          alt="A Legbefolyásosabb Magyar Nők 2019"
        >
        <div class="intro">
          Lassan, de emelkedik a felsőbb pozícióba kerülő nők száma,
          a valós befolyáshoz és a hatalomhoz viszont mintha egyre kevesebben,
          kizárólag egy egyre szűkülő kör tagjai férnének hozzá. A magyar Forbes ötödik,
          a legbefolyásosabb nőket soroló listája ezért is bővül egy új kategóriával: azok sorával,
          akiknek hatalma korlátos, de akikre örömmel figyelünk.
        </div>
        <div class="szerk">
          Írta és szerkesztette: Bánlaki D. Stella <br>
          Továbbá: Bujdosó Bori, Laza Bálint és Smejkál Péter
        </div>
        <div
          class="mopener"
          @click="toggler"
        >
          {{openertext}}
        </div>
      </div>
      <div class="modszertan">
        <div class="expanded">
          <div class="title">
            Módszertan
          </div>
          <div
            class="closebtn"
            @click="toggler"
          >x</div>
          <p>A magyar Forbes ötödik alkalommal készítette el a legbefolyásosabb magyar nők
            listáját – talán a legszubjektívebb listánkat mind közül. A legnagyobb jelentőségük
            azért itt is a számoknak volt (például, hogy az adott vezető mekkora büdzséért
            és létszámért felel, vagy a szakértelme milyen értéket képvisel a piacon), és fontos
            volt, hogy az elmúlt egy év alatt a korábbiakhoz képest hogyan változott mindez,
            milyen eredményeket ért el, merre ível a karrierje vagy az általa vezetett cég,
            intézmény pályája. Utóbbinak köze lehet ahhoz is, hogy a vezető mennyire ápol jó
            kapcsolatokat a piac és az ország más befolyásos vezetőivel, milyen lobbierővel
            bír akár kormányzati körökben, akár nemzetközi szinten.</p>
          <p>Végső soron a lista összeállításakor fontos volt az is, hogy mekkora a felhajtás
            egy-egy személy körül – milyen eléréssel rendelkezik az informális szakmai és
            női körökben, a LinkedInen és más közösségi platformokon; vállal-e közéleti szerepet,
            vállal-e kockázatot és plusz munkát azért, hogy a környezetét is fejlessze,
            kiáll-e fontos társadalmi ügyekért, akár a cége nevében is.</p>
          <p>Az adatok jelentős részét a Bisnode speciális kutatása biztosította a Forbesnak.
            A további információk begyűjtésében több tucat háttérbeszélgetés és informátor
            segítette a munkánkat. A lista szereplőinek sorrendjéről a fenti kritériumok
            figyelembevétele mellett szavazással döntött a Forbes szerkesztősége.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Lead',
  data() {
    return {
      openertext: 'módszertan',
    };
  },
  methods: {
    scrollTop(pos) {
      // window.scrollTo(0, 0);
      window.scrollTo({
        behavior: 'smooth',
        left: 0,
        top: pos,
      });
    },
    toggler() {
      const container = document.querySelector('.expanded');
      const scrollto = document.querySelector('.mopener').offsetTop;
      container.classList.toggle('show');
      container.setAttribute('style', `width:${(document.body.clientWidth) - 120}px`);
      if (this.openertext === 'módszertan') {
        this.openertext = 'bezár';
        this.scrollTop(scrollto);
      } else {
        this.openertext = 'módszertan';
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.lead {
  overflow: hidden;
}
.container {
  font-family: "Montserrat", sans-serif;
  font-style: italic;
}
.inner {
  font-size: 19px;
  position: relative;
  padding: 90px 0 80px 0;
  display: grid;
  grid-template-columns: 1fr 650px 3%;
  grid-template-rows: auto auto auto auto;
  display: -ms-grid;
  -ms-grid-columns: 1fr 650px 5%;
  -ms-grid-rows: auto auto auto auto;
  width: calc(100% - 70px);
  margin-left: auto;
}
.headline,
.intro,
.szerk,
.mopener {
  grid-column: 2/3;
  -ms-grid-column: 2;
  justify-self: center;
  text-align: center;
}
.headline {
  width: 75%;
  margin-bottom: 30px;
  grid-row: 1/2;
  -ms-grid-row: 1;
}
.intro {
  grid-row: 2/3;
  -ms-grid-row: 2;
}
.szerk {
  grid-row: 3/4;
  -ms-grid-row: 3;
}
.mopener {
  grid-row: 4/5;
  -ms-grid-row: 4;
}
.szerk {
  margin-top: 20px;
}
.mopener,
.szerk {
  font-size: 14px;
}
.mopener {
  text-decoration: underline;
  cursor: pointer;
  display: inline-block;
}
.modszertan {
  position: relative;
}
.closebtn {
  display: block;
  position: absolute;
  right: 15px;
  top: 15px;
  cursor: pointer;
  color: #f0271d;
  text-transform: uppercase;
  font-weight: 700;
}
.expanded {
  left: 0;
  top: 0;
  z-index: 4;
  padding: 20px 30px;
  border-radius: 8px;
  display: none;
  position: relative;
  font-size: 15px;
  font-style: normal;
  border: 1px solid #f0271d;
}
.expanded.show {
  display: block;
  margin: 10px 0 20px 0;
}
.title {
  font-weight: 700;
}
.modszertan p {
  margin-block-start: 5px;
  margin-block-end: 0;
}
.headbg {
  position: absolute;
  z-index: -1;
  left: 0;
  top: 0;
  height: 100%;
}
@media screen and (max-width: 1350px) {
  .inner {
    grid-template-columns: 1fr 50%;
    -ms-grid-columns: 1fr 50%;
  }
  .headline {
    width: 90%;
  }
}
@media screen and (max-width: 1220px) {
  .inner {
    width: 100%;
    grid-template-columns: 1fr 45%;
    -ms-grid-columns: 1fr 45%;
  }
  .headline {
    width: 85%;
  }
}
@media screen and (max-width: 1100px) {
  .inner {
    padding: 150px 0 30px 0;
    grid-template-columns: 1fr 84%;
    -ms-grid-columns: 1fr 84%;
  }
}
@media screen and (max-width: 767px) {
  .inner {
    padding: 170px 0 0 0;
  }
}
@media screen and (max-width: 520px) {
  .inner {
    padding: 200px 0 0 0;
  }
  .headline {
    width: 100%;
  }
}
</style>
